import { render, staticRenderFns } from "./BasicTask.vue?vue&type=template&id=6ae4be54&scoped=true"
import script from "./BasicTask.vue?vue&type=script&lang=ts"
export * from "./BasicTask.vue?vue&type=script&lang=ts"
import style0 from "./BasicTask.vue?vue&type=style&index=0&id=6ae4be54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4be54",
  null
  
)

export default component.exports